import React from 'react';
import { Text, View, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';

const ToggleButtons = (props) => {

  const pressButton1 = () => {
    props.setValue(true);
    change(true);
  }
  const pressButton2 = () => {
    props.setValue(false);
    change(false);
  }
  const change = (value) => {
    if (props.onChange && typeof props.onChange === 'function') {
      props.onChange(value);
    }
  }

  return (
    <View style={CS.rowContainer}>
      <TouchableOpacity activeOpacity={0.6} onPress={pressButton1} style={[styles.tabButton, styles.tabButtonLeft, (props.value && styles.tabButtonActive)]}>
        <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.text, (props.value && CS.darkText)]}>{props.button1Text}</Text>
      </TouchableOpacity>
      <TouchableOpacity activeOpacity={0.6} onPress={pressButton2} style={[styles.tabButton, styles.tabButtonRight, (!props.value && styles.tabButtonActive)]}>
        <Text style={[CS.smallText, CS.boldText, CS.lightText, styles.text, (!props.value && CS.darkText)]}>{props.button2Text}</Text>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  tabButton: {
    // paddingVertical: 12,
    // paddingHorizontal: 20,
    paddingVertical: 10,
    paddingHorizontal: 5,
    alignItems: 'center',
    flex: 1,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.textInputBackground,
  },
  tabButtonActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  tabButtonLeft: {
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
  },
  tabButtonCenter: {
    flex: 0,
  },
  tabButtonRight: {
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
  },
  text: {
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap',
      }
    })
  }
});

export default ToggleButtons;